module.exports = __webpack_public_path__ + "public/img/ico-tabbar-active-overview.8e18fe97.svg";